<template>
  <div class="d-flex flex-column align-items-center">
    <div class="app-container d-flex flex-column align-items-center col-12 col-sm-8 col-md-6 col-lg-5 col-xl-3 vue-container">
      <LoadingOverlay class="col-12 col-sm-8 col-md-6 col-lg-5 col-xl-3" v-if="this.isLoading"/>
      <div class="router-view-wrapper" :class="{ 'no-footer': !shouldShowFooter }">
        <router-view />
      </div>
      <div v-if="shouldShowFooter" class="d-flex flex-column justify-content-center align-items-center col-11 mt-4 mb-2">
        <FooterComponent />
      </div>
    </div>
  </div>
</template>

<style lang="scss">
@import "assets/style/global";

.vue-container {
  position: relative;
  height: 100svh;
  overflow: hidden;
  background: #F6F3FF;
}

.router-view-wrapper {
  flex: 1;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  padding-bottom: 80px;
  transition: padding-bottom 0.3s ease;
}

.router-view-wrapper.no-footer {
  padding-bottom: 0;
}
</style>

<script>
import LoadingOverlay from "@/views/components/LoadingOverlay";
import {mapState, mapMutations} from "vuex";
import {setServiceIds} from "@/config";
import FooterComponent from "@/views/components/FooterComponent.vue";
import {calculateCurrentSeason} from "@/functions/setSeasonalConfig"

export default {
  components: {FooterComponent, LoadingOverlay},
  computed: {
    ...mapState(['isLoading', 'brandConfig', 'user']),
    shouldShowFooter() {
      const routesWithoutFooter = [
        'landing',
        'login',
        'submit-otp',
        'username',
        'upgrade',
        'upgrade-package',
        'package-confirmation',
        'game-play',
        'end-screen',
        'bonus-round',
        'bonus-end-screen',
        'bonus-end-loss',
        'pop-up',
        'doi',
        'doi-success',
         'terms',
        'spotify-callback'
      ];

      return !routesWithoutFooter.includes(this.$route.name);
    }
  },
  methods: {
    ...mapMutations(['setShowAddToHomeScreen', 'setDeferredPrompt', 'setProductId','setCurrentSeason']),

    initializeSeason() {
      const currentSeason = calculateCurrentSeason();

      this.setCurrentSeason(currentSeason);
      console.log('Current season initialized:', currentSeason || 'default');
    }
  },

  beforeMount() {
    setServiceIds()
    this.initializeSeason();
  }
}
</script>